export const SubmitHandler = async ({ submitData = {}, url }: { submitData: any; url: string }) => {
    const response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(submitData),
        headers: {
            'Content-Type': 'application/json',
            'x-api-key': 'b4204711-65da-4d8a-8801-f060ba8a0b62',
        },
    })

    if (!response.ok) {
        throw new Error(`Request failed: ${response.status}`)
    } else {
        return { data: 'success' }
    }
}

export const GetTokenHandler = async ({ getTokenUrl = '' }) => {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            AccessHeader: '*',
        },
    }

    const response = await fetch(`${getTokenUrl}`, requestOptions)
        .then(resp => {
            return { result: resp.text() }
        })
        .catch(error => {
            return { result: 'error', status: error }
        })

    return response
}

export const SEQHandler = async ({
    submitData = {},
    url = '',
    apiKey = '',
}: {
    submitData: any
    url: string
    apiKey?: string
}) => {
    const response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(submitData),
        headers: {
            'Content-Type': 'application/json',
            'X-Log-Api-Key': apiKey || '',
        },
    })

    if (!response.ok) {
        return { data: 'error' }
    } else {
        return { data: 'success' }
    }
}

export function getSessionId() {
    let id = sessionStorage.getItem('sessionId')
    if (!id) {
        id = crypto.randomUUID()
        sessionStorage.setItem('sessionId', id)
    }
    return id
}
